<template>
  <b-modal id="deviceBrandCreateModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{$t('views.excmdevicebrand.create.title')}}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <Create :openedInModal="true"></Create>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import Create from '../../Create'
export default {
  name: 'DeviceBrandCreateModal',
  components: {
    Create
  },
  computed: {
    show () {
      return this.$store.state.modals.excmdevicebrand.form.show
    },
    close () {
      return this.$store.state.modals.excmdevicebrand.form.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'close': function (val) {
      if (this.close === 1) {
        this.$store.state.modals.excmdevicebrand.form.close = 0
        this.closeModal()
      }
    }
  },
  methods: {
    openModal () {
      if (this.show === 1) {
        this.$store.state.modals.excmdevicebrand.form.show = 0
        this.$bvModal.show('deviceBrandCreateModal')
      }
    },
    closeModal () {
      this.$bvModal.hide('deviceBrandCreateModal')
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
